import { render } from "./SystemSetting.vue?vue&type=template&id=3afa367e&scoped=true"
import script from "./SystemSetting.vue?vue&type=script&lang=js"
export * from "./SystemSetting.vue?vue&type=script&lang=js"

import "./SystemSetting.vue?vue&type=style&index=0&id=3afa367e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afa367e"]])

export default __exports__